export const VIEW_ENTER = 'loginConsents/VIEW_ENTER';

export const viewEnter = () => ({
  type: VIEW_ENTER,
});
